import { render, staticRenderFns } from "./App.vue?vue&type=template&id=6b5af52e&scoped=true&lang=html&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./assets/common.css?vue&type=style&index=0&lang=css&"
import style1 from "./assets/font/font.css?vue&type=style&index=1&lang=css&"
import style2 from "./App.vue?vue&type=style&index=2&id=6b5af52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5af52e",
  null
  
)

export default component.exports